<div class="modal fade" *ngIf="webApi.isLoggedIn()" id="videos-locked-popup-modal" tabindex="-1" aria-labelledby="videosLockedModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content box-design">
        <div class="content-section">
            <p>You do not have access to this video. Please <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#subscription-update-modal">Update Subscription</a>.</p>
            <div class="d-flex justify-content-center mt-3">
                <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-gold mt-2 ml-auto">Ok</button>
            </div>
        </div>
      </div>
    </div>
  </div>